import { RoutineColors } from "@/utilities/routineColors";
import type { Routine } from "instantdb/types";

export const MOOD_ROUTINES: Partial<Routine>[] = [
  {
    id: "morning-gratitude-practice",
    title: "Morning Gratitude Practice",
    symbol: "🌞",
    description: "Start your day with positivity and mindfulness",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[3].value,
    steps: [
      {
        id: "mood-gratitude-1",
        title: "Find a quiet space",
        description: "Sit somewhere comfortable and free from distractions",
      },
      {
        id: "mood-gratitude-2",
        title: "Reflect on positives",
        description: "Think about three things you're grateful for today",
      },
      {
        id: "mood-gratitude-3",
        title: "Write them down",
        description: "Journal your gratitude thoughts to reinforce them",
      },
    ],
  },
  {
    id: "mood-tracking",
    title: "Mood Tracking",
    symbol: "🌞",
    description: "Track your emotions to identify patterns and triggers",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[4].value,
    steps: [
      {
        id: "mood-tracking-1",
        title: "Morning check-in",
        description: "Note how you're feeling when you wake up",
      },
      {
        id: "mood-tracking-2",
        title: "Midday reflection",
        description: "Check in with your emotions around lunchtime",
      },
      {
        id: "mood-tracking-3",
        title: "Evening assessment",
        description: "Record your mood before bed and any notable events",
      },
    ],
  },
  {
    id: "social-connection",
    title: "Social Connection",
    symbol: "🌞",
    description: "Foster positive relationships to support emotional wellbeing",
    dailyRoutine: false,
    selectedDays: [{ day: "saturday", datetime: "10:00:00.000Z" }],
    color: RoutineColors[5].value,
    steps: [
      {
        id: "mood-social-1",
        title: "Reach out",
        description: "Contact a friend or family member you care about",
      },
      {
        id: "mood-social-2",
        title: "Quality time",
        description: "Spend time talking or doing an activity together",
      },
      {
        id: "mood-social-3",
        title: "Express appreciation",
        description: "Let them know you value them in your life",
      },
    ],
  },
];
